import { SRCInfo } from 'types/data';
//START GENAI@CHATGPT4
export const getCardBrandApiKey = (srcInfo: SRCInfo, cardBrand: string) => {
  const cardBrandSdk = srcInfo.sdks.find(
    sdk => sdk.cardBrand.toUpperCase() === cardBrand.toUpperCase()
  );

  return cardBrandSdk ? cardBrandSdk.apiKey : null;
};
//END GENAI@CHATGPT4
